import React from "react";
import { Provider } from "react-redux";
import ReduxPromise from "redux-promise";
import { createStore, applyMiddleware } from "redux";
import reducers from "./reducers";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Map from "./containers/Map/Map";
import Report from "./containers/Report/Report";
import Login from "./containers/Login/Login";
import "antd/dist/antd.less";
import "./App.css";

const store = createStore(reducers, applyMiddleware(ReduxPromise));

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <Router>
          <Switch>
            <Route exact path="/" render={(props) => <Map />} />
            <Route exact path="/scenario/:id" render={(props) => <Map />} />
            <Route
              exact
              path="/scenario/:id/report"
              render={(props) => <Report />}
            />
            <Route exact path="/:city/report" render={(props) => <Report />} />
            <Route exact path="/map" render={(props) => <Map />} />
            <Route exact path="/login" render={(props) => <Login />} />
          </Switch>
        </Router>
      </Provider>
    </div>
  );
}

export default App;
